import React, {useMemo} from 'react';
import {useMouseOver} from 'shared/helpers/useMouseOver';
import Icon from 'shared/Icon';

export enum ConfirmationKey {
    FREIGHT = 'freight',
    CHECKOUT = 'checkout',
}

interface ConfirmationTabTitleProps {
    isActive: boolean;
    activeIcon: string;
    icon: string;
    title: string;
}

export const ConfirmationTabTitle = ({
    isActive,
    icon,
    activeIcon,
    title,
}: ConfirmationTabTitleProps) => {
    const {isMouseOverComponent, handleMouseEnter, handleMouseExit} =
        useMouseOver();

    const navIcon = useMemo(() => {
        if (isActive || isMouseOverComponent) {
            return activeIcon;
        }

        return icon;
    }, [isActive, activeIcon, icon, isMouseOverComponent]);

    return (
        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseExit}>
            <Icon iconName={navIcon} />
            <span>{title}</span>
        </div>
    );
};
